var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.89813L4.46967 8.42846L3.93934 7.89813L4.46967 7.3678L5 7.89813ZM8.22813 15.75C7.81391 15.75 7.47813 15.4142 7.47813 15C7.47813 14.5858 7.81391 14.25 8.22813 14.25L8.22813 15.75ZM8.22812 11.1262L7.6978 11.6566L4.46967 8.42846L5 7.89813L5.53033 7.36779L8.75845 10.5959L8.22812 11.1262ZM5 7.89813L4.46967 7.3678L7.69779 4.13967L8.22812 4.67L8.75845 5.20033L5.53033 8.42846L5 7.89813ZM5 7.89813L5 7.14813L11.7791 7.14812L11.7791 7.89812L11.7791 8.64812L5 8.64813L5 7.89813ZM11.7791 15L11.7791 15.75L8.22813 15.75L8.22813 15L8.22813 14.25L11.7791 14.25L11.7791 15ZM15.33 11.4491L16.08 11.4491C16.08 13.8244 14.1544 15.75 11.7791 15.75L11.7791 15L11.7791 14.25C13.326 14.25 14.58 12.996 14.58 11.4491L15.33 11.4491ZM11.7791 7.89812L11.7791 7.14812C14.1544 7.14812 16.08 9.07372 16.08 11.4491L15.33 11.4491L14.58 11.4491C14.58 9.90215 13.326 8.64812 11.7791 8.64812L11.7791 7.89812Z",
    fill: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/Previous.391e02a0c8ae0b27d2e828443e1ab71b.svg";
export { ForwardRef as ReactComponent };